import React from 'react';
import AboutIntro from './Intro/AboutIntro';
import AboutUs from './AboutUs/AboutUs';
import SectionTitle from '../../SectionTitle.style';


function AboutPage() {
  return (
    <div style={{ background: '#212529', marginTop: '50px'}}>
      <AboutIntro />
      <AboutUs />

    </div>
  );
}

export default AboutPage;
